var $ = global.jQuery = global.$ = require('jquery');
var parser = require('./lib/parser');

var svg4everybody = require('./third-party/svg4everybody');

require('modernizr');
require('./widgets/index');
require('./widgets/index_PTS');
require('./third-party/iframeResizer');
require('jquery.cookie');
require('./third-party/jquery.cookiecuttr');
//require('./third-party/float-panel');
//require('./third-party/jquery.label_better.min');

$('iframe').iFrameResize();

var app = {
  controllers: {
    home: require('./controllers/home')
  },
  init: function(){
    var self = this;
    //$('.navigation').stickUp();

    parser.parse('body',function(){
      $('[data-controller]').each(function(){
        var controller = $(this).data('controller');

        if (self.controllers[controller]){
          //If the controller exists, initialise it
          self.controllers[controller].init($(this));
        }
      });
    });
  }
};

app.init();

$(function(){
  $.cookieCuttr({
    cookieAnalytics: false,
    cookiePolicyLink: $('[data-cookie-policy-href]').data('cookiePolicyHref')
  });
  svg4everybody();
  $('.rte table').each(function(){
    if (!$(this).parents().eq(0).hasClass('table-overflow')) {
      $(this).wrap('<div class="table-overflow"></div>');
    }
  });
});



/*****************
 ** WEBPACK FOOTER
 ** ./source/scripts/app_PTS.js
 ** module id = 260
 ** module chunks = 1
 **/